module.exports = __webpack_public_path__ + "img/gate_exit_blk.a2246420.svg";